import { render, staticRenderFns } from "./shop-product-item.vue?vue&type=template&id=200bf9ec&"
import script from "./shop-product-item.vue?vue&type=script&lang=js&"
export * from "./shop-product-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports